<dx-popup #popupAptBooker [width]="600" [height]="300" [minWidth]="400" [minHeight]="300" [showTitle]="true"
    [resizeEnabled]=true position="center" [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false">
    <div *dxTemplate="let data of 'content'" style="overflow-y:scroll">
        <div id="textBlock" style="white-space:pre-wrap;">
            {{notesText}}
        </div>
    </div>
</dx-popup>